import * as React from 'react';
import {Col, Container, Row, Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import AlmacenForm from './almacen-form';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import MeepoServiceClient from '../../../middleware/meepo-client';
import {IProductoADevolver, IResumenDiario} from '../../../utils/models';
import MeepoState from '../../../reduxstore/meepo-state';
import {connect, Store} from 'react-redux';
import {error} from '../../../utils/notification-actions';
import ReactTable from 'react-table';
import Panel from '../../../theme/components/Panel';
import classnames from 'classnames';

interface IState {
    cambios: IProductoADevolver[];
    productos: IProductoADevolver[];
    activeTab: string;

}

interface IProps {
    resumenDiario: IResumenDiario[];
}

const mapStateToProps = (state) => {
    const stateProps = {
        resumenDiario: state.app.getResumenDiarioXRuta(),
    };
    return stateProps;
};

class AlmacenView extends React.Component<IProps, IState> {

    @lazyInject(TYPES.MEEPO_SERVICE)
    public apiClient: MeepoServiceClient;

    @lazyInject(TYPES.REDUX_STORE)
    public store: Store<MeepoState>;

    constructor(props) {
        super(props);
        this.state = {
            cambios: [],
            activeTab: '1',
            productos: []
        }
    }

    private get header() {
        return [
            {
                accessor: 'producto_id',
                Header: 'Código',
                className: 'center'
            },
            {
                accessor: 'producto_descripcion',
                Header: 'Descripción',
            },
            {
                accessor: 'cantidad',
                Header: 'Cantidad',
                className: 'center'
            }
        ]
    }

    public handleObtener = async (values) => {
        try {
            const productos = await this.apiClient.obtenerProductosADevolver(values.rutaId.value);
            const cambios = await this.apiClient.obtenerCambiosADevolver(values.rutaId.value);
            this.setState({productos, cambios})
        } catch (ex) {
            this.store.dispatch(error('Error', 'Error interno al obtener liquidaciones'));
        }
    };

    private toggleTabs = (tab: string) => {
      if(this.state.activeTab !== tab){
          this.setState({activeTab: tab});
      }
    };


    public render() {
        return (
            <Container className='dashboard'>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Reporte de almacén</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <AlmacenForm onSubmit={this.handleObtener} resumenDiario={this.props.resumenDiario}/>
                    </Col>
                    <Col md={9}>
                        <Panel xs={12} md={12} divider={true} title='Productos a devolver'>
                            <Nav tabs={true}>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '1' })}
                                        onClick={() => {
                                            this.toggleTabs('1');
                                        }}
                                    >
                                        Productos
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '2' })}
                                        onClick={() => {
                                            this.toggleTabs('2');
                                        }}
                                    >
                                        Cambios
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId='1'>
                                    <ReactTable
                                        style={{
                                            margin: 'auto',
                                            marginTop: '25px'
                                        }}
                                        className='rt-custom-table -highlight'
                                        columns={this.header} data={this.state.productos} showPagination={false}
                                        resizable={false}
                                        pageSize={this.state.productos.length}/>
                                </TabPane>
                                <TabPane tabId='2'>
                                    <ReactTable
                                        style={{
                                            margin: 'auto',
                                            marginTop: '25px'
                                        }}
                                        className='rt-custom-table -highlight'
                                        columns={this.header} data={this.state.cambios} showPagination={false}
                                        resizable={false}
                                        pageSize={this.state.cambios.length}/>
                                </TabPane>
                            </TabContent>

                        </Panel>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect(mapStateToProps)(AlmacenView);





// WEBPACK FOOTER //
// ./src/components/pages/almacen/almacen.tsx